var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"serving-size-container"},[_c('span',{staticClass:"serving-size-label"},[_vm._v("Serving Size")]),_c('span',{staticClass:"serving-size-value"},[_vm._v(_vm._s(_vm.item.ServingDisplay))])])}
var staticRenderFns = []

export { render, staticRenderFns }